import { render, staticRenderFns } from "./DialogMaterial.vue?vue&type=template&id=33ce60ba&scoped=true"
import script from "./DialogMaterial.vue?vue&type=script&lang=js"
export * from "./DialogMaterial.vue?vue&type=script&lang=js"
import style0 from "./DialogMaterial.vue?vue&type=style&index=0&id=33ce60ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce60ba",
  null
  
)

export default component.exports